// Copyright (c) 2016 Deere & Company

import './registration-result.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../shared/components/labeled-string';
import {Link} from 'react-router';
import ProductImage from './../../../shared/components/product-image';
import Registration from '@deere/cps-it.warranty-model-factory/lib/registration';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';

class RegistrationResult extends Component {

    state = {
        showConfirmDelete: false
    };

    handleOpenConfirmationModal = () => {

        document.body.classList.add('warranty-modal-is-open');
        this.setState({showConfirmDelete: true});

    };

    handleCloseConfirmationModal = () => {

        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmDelete: false});

    };

    handleDeleteClick = () => {

        this.props.deleteAction(this.props.registration.id);
        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmDelete: false});

    };

    render() {

        return (
            <section className='registration-result'>
                <section>
                    <div className='product-image'>
                        <ProductImage
                            imageURL={this.props.registration.product.imageUrl}
                            placeHolderText={this.props.registration.product.baseMachineCode}
                        />
                    </div>
                    <main>
                        <div className='product-header'>
                            <Link
                                className='product-title'
                                to={`/products/${this.props.registration.product.pin}`}
                            >
                                {this.props.registration.product.pin}
                            </Link>
                        </div>
                        <div className='data-pairs'>
                            <LabeledString
                                className='responsible-dealer'
                                data={buildDealer(this.props.registration.responsibleDealer, this.context.user.settings.dealer.displayFormat.key)}
                                label='DEALER'
                            />
                            <LabeledString
                                className='creation-date'
                                data={buildDate(this.props.registration.creationDate, this.context.user.settings.general.dateFormat.key)}
                                label='REGISTERED'
                            />
                        </div>
                        <div className='errors'>
                            {this.props.registration.errors.map((error, index) =>
                                <LabeledString
                                    data={error.description}
                                    key={index}
                                    label='ERROR'
                                />)
                            }
                        </div>
                    </main>
                </section>
                <footer>
                    <section className='button-group'>
                        <button onClick={this.handleOpenConfirmationModal}>
                            <FormattedMessage id='DELETE'/>
                        </button>
                        <Link
                            className='primary'
                            to={`/products/register-product?registrationId=${encodeURIComponent(this.props.registration.id)}`}
                        >
                            <FormattedMessage id='EDIT'/>
                        </Link>
                    </section>
                </footer>
                <ConfirmationModal
                    confirmMessage='CONFIRM_DELETE_REGISTRATION'
                    isOpen={this.state.showConfirmDelete}
                    onClose={this.handleCloseConfirmationModal}
                    onConfirm={this.handleDeleteClick}
                    title='DELETE_REGISTRATION'
                />
            </section>
        );

    }
}

RegistrationResult.displayName = 'RegistrationResult';
RegistrationResult.propTypes = {
    deleteAction: PropTypes.func.isRequired,
    registration: PropTypes.instanceOf(Registration).isRequired
};
RegistrationResult.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default RegistrationResult;



// WEBPACK FOOTER //
// ./src/product/registration-review/components/registration-result.js